import { tModule } from './moduleLabels';

export const DOCUMENT_TITLE_APP = 'DQFleet';

const DENIED_SEGMENTS = new Set(['overview', 'new', 'manage', 'edit']);

/** Längre prefix vinner. Sista path-delen matchar inte modulnyckeln. */
const PREFIX_TITLES: { prefix: string; module?: string; key?: string }[] = [
  { prefix: '/fleet/overview', module: 'fleet-overview' },
  { prefix: '/fleet/procurement', module: 'vehicle-procurement' },
  { prefix: '/admin/kodverk', module: 'econ-kodverk' },
  { prefix: '/admin/sysadmin/carinfo-filter-config', module: 'carinfo-filter' },
  { prefix: '/admin/sysadmin/trip-sync', key: 'sysadmin.tripSync.title' },
  { prefix: '/system/deque/track', module: 'track-playback' },
  { prefix: '/booking/bokningsunderlag', module: 'booking-basis' },
  { prefix: '/booking/quick', module: 'quick-booking' },
  { prefix: '/demo/poolcar', key: 'documentTitle.poolCar' },
].sort((a, b) => b.prefix.length - a.prefix.length);

const EXACT_KEYS: Record<string, string> = {
  '/': 'nav.dashboard',
  '/admin': 'modules.administration.title',
  '/manual': 'manual.title',
  '/profile': 'nav.profile',
  '/testing': 'documentTitle.testRunner',
  '/vehicles': 'nav.vehicles',
};

function translated(t: (key: string) => unknown, key: string): string | null {
  const val = t(key);
  if (typeof val === 'string' && val.length > 0 && val !== key) return val;
  return null;
}

function segmentTitle(t: (key: string) => unknown, segment: string): string | null {
  if (!segment || DENIED_SEGMENTS.has(segment)) return null;
  if (/^\d+$/.test(segment)) return null;
  if (/^[0-9a-f]{8}-/i.test(segment)) return null;
  const direct = tModule(t, segment, 'title');
  if (direct) return direct;
  if (segment.includes('-')) return tModule(t, segment.replace(/-/g, '_'), 'title');
  return null;
}

/** Vynamn för flik och sidhuvud. null när routen saknar känt namn. */
export function resolveViewTitle(pathname: string, t: (key: string) => unknown): string | null {
  const path = pathname.split('?')[0].replace(/\/+$/, '') || '/';

  const exact = EXACT_KEYS[path];
  if (exact) return translated(t, exact);

  for (const row of PREFIX_TITLES) {
    if (path === row.prefix || path.startsWith(`${row.prefix}/`)) {
      if (row.key) {
        const named = translated(t, row.key);
        if (named) return named;
      }
      if (row.module) {
        const named = tModule(t, row.module, 'title');
        if (named) return named;
      }
    }
  }

  const segments = path.split('/').filter(Boolean);
  for (let i = segments.length - 1; i >= 0; i -= 1) {
    const named = segmentTitle(t, segments[i]);
    if (named) return named;
  }
  return null;
}

export function formatDocumentTitle(viewName: string | null | undefined): string {
  const name = viewName?.trim();
  if (!name || name === DOCUMENT_TITLE_APP) return DOCUMENT_TITLE_APP;
  return `${name} – ${DOCUMENT_TITLE_APP}`;
}
